// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StatusIllustration__container-ae9424 {
  display: block;
  width: 80px;
  height: 80px;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/StatusIllustration/StatusIllustration.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AACF","sourcesContent":[".container {\n  display: block;\n  width: 80px;\n  height: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StatusIllustration__container-ae9424`
};
module.exports = ___CSS_LOADER_EXPORT___;
